import { useState } from 'react';
import PropTypes from 'prop-types';

import AppDialog from '#/modules/commonComponents/dialog/AppDialog';
import { Input } from '#/modules/commonComponents/form/Input';

/** 發出報價單：有效截止日選填（留空＝後端以台北發出日 +14 天）。 */
const QuotationIssueDialog = ({ open, onOpenChange, isPending = false, onConfirm }) => {
  const [validUntil, setValidUntil] = useState('');

  return (
    <AppDialog
      open={open}
      onOpenChange={onOpenChange}
      title="發出報價單"
      description="發出後客戶、聯絡資料、付款條件與報價項目即凍結，也不能刪除；之後只能改內部備註。"
      onCancel={() => onOpenChange(false)}
      onConfirm={() => onConfirm(validUntil || undefined)}
      confirmText={isPending ? '發出中…' : '發出'}
      cancelText="取消"
      confirmDisabled={isPending}
    >
      <label htmlFor="quotationValidUntil" className="text-sm font-medium text-gray-700">
        有效截止日（選填）
      </label>
      <Input
        id="quotationValidUntil"
        type="date"
        value={validUntil}
        onChange={(event) => setValidUntil(event.target.value)}
      />
      <p className="text-xs text-muted-foreground">
        留空會自動設為發出日起 14 天；不可早於今天。截止日當天仍是「已發出」，隔天起顯示「已過期」。
        所有主項目須填齊品名、數量、單位與單價，客戶與付款條件須仍為啟用。
      </p>
    </AppDialog>
  );
};

QuotationIssueDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onOpenChange: PropTypes.func.isRequired,
  isPending: PropTypes.bool,
  onConfirm: PropTypes.func.isRequired,
};

export default QuotationIssueDialog;
